import { estadoUsuario } from "@pcgerente-node/pcg-comun"
import { USUARIO } from "@pcgerente-node/pcg-comun/dist/DTOs"
import axios, { AxiosResponse } from "axios"
import { useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { guardarUsuarioEnRedux } from "../../../redux/actions/actionAuth"
import { baseURL, handleResponse, headers } from "../../../redux/helpersRedux"
import { RootState, useAppDispatch } from "../../../redux/store"
import "../../../styles/recuperar.css"
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import Loading from "../../helpers/Loading/Loading"
import UseAuth from "../../useAuth/useAuth"


interface childsProps {
    restablecer: boolean
    autenticado: boolean
}

class formRestablecerContrasenia{
    password: string = ""
    confirmacionPassword: string = ""
    error?: string
}

const RestablecerContrasenia: React.FC<childsProps> = () => {

    const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
    const {logout} = UseAuth()
    const [show, setShow] = useState(false)
    const [state, setState] = useState<formRestablecerContrasenia>(new formRestablecerContrasenia())
    const dispatch = useAppDispatch()
    
    return (
        usuarioVM._ItemActivo?
        <div className="form-container">
            <div className="form-form">
                <div className="form-form-wrap">
                    <div className="form-container">
                        <div className="form-content">

                            <h1 className="">Restablecer Contraseña</h1>
                            { usuarioVM.loading === false && !usuarioVM.autenticado?
                                <>
                                    <p className="signup-link">{state.error}</p>
                                    <form className="text-left" onSubmit={(e) => e.preventDefault()}>
                                            <div id="email-field" className="field-wrapper input">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-at-sign"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
                                                <input 
                                                    id="contrasenia" 
                                                    name="string" 
                                                    type={show ? "text" : "password"} 
                                                    placeholder="Nueva contraseña"
                                                    value={state.password}
                                                    onKeyDown={(e) => e.key === "Enter"? e.preventDefault(): null }
                                                    onChange={(e) => handleInfo("password", e.target.value)}
                                                />
                                            </div>
                                            <div id="email-field" className="field-wrapper input">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-at-sign"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
                                                <input id="confirmarContrasenia" 
                                                    name="string" 
                                                    type={show ? "text" : "password"} 
                                                    placeholder="Confirmar nueva contraseña"
                                                    onKeyDown={(e) => e.key === "Enter"? e.preventDefault(): null }
                                                    value={state.confirmacionPassword}
                                                    onChange={(e) => handleInfo("confirmacionPassword", e.target.value)}
                                                />
                                            </div>
                                            <div className="field-wrapper toggle-pass mb-4" >
                                                <p className="d-inline-block">Mostrar Contraseña</p>
                                                <label className="switch s-primary">
                                                    <input type="checkbox" 
                                                    id="toggle-password" 
                                                    className="d-none" 
                                                    onClick={() => setShow(!show)} 
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                            <div className="d-sm-flex justify-content-around">
                                                    <button 
                                                        className="btn btn-danger" 
                                                        onClick={() => logout()}>
                                                            Cancelar
                                                    </button>
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={() =>  cambiarContrasenia()}>Guardar
                                                    </button>
                                            </div>
                                    </form>
                                </>
                                :
                                <>
                                    <h5 className="text-success text-center mt-3 mb-4">Su contraseña ha sido restablecida, por favor vuelva a iniciar sesion </h5>
                                    <div className="d-flex justify-content-center">
                                        <Link to="/login">
                                            <button className="btn btn-primary" onClick={() => logout()}>Iniciar Sesion</button>
                                        </Link>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-image">
                <div className="l-image">
                </div>
            </div>
        </div>
        :<Loading/>
    )
    
    function handleInfo(type: "password"|"confirmacionPassword", value: string){
        setState({
            ...state,
            [type]: value,
            error: undefined
        })
    }
    async function cambiarContrasenia(){
        const usuario = usuarioVM._ItemActivo
        try {
            if (state.password !== state.confirmacionPassword){
                throw new Error("Las contraseñas ingresadas no coinciden")
            }else if(state.password.length < 8){
                throw new Error("La contraseña necesita tener al menos 8 caracteres")
            }
            usuario.estado = estadoUsuario.Activo
            usuario.password = state.password
            const response = await axios.put(`${baseURL}USUARIO/${usuario.id}`, usuario, headers)
                .then((res: AxiosResponse<IApiResponse<USUARIO>>) => handleResponse(res))
            if (response.id > 0) {
                    dispatch(guardarUsuarioEnRedux(response))
            }
        } catch (error) {
            if (error instanceof Error){
                setState({...state, error: error.message})
            }
        }
    }
}

export default RestablecerContrasenia